export const guidelinePrefabs = {
  studio: {
    centre: {
      direction: 'vertical',
      position: 0.5,
      snap: 'middle',
    },
    left: {
      direction: 'vertical',
      position: 0,
      snap: 'edge',
    },
    right: {
      direction: 'vertical',
      position: 1,
      snap: 'edge',
    },
    top: {
      direction: 'horizontal',
      position: 0,
      snap: 'edge',
    },
    bottom: {
      direction: 'horizontal',
      position: 1,
      snap: 'edge',
    },
    middle: {
      direction: 'horizontal',
      position: 0.5,
      snap: 'middle',
    },
    topmiddle: {
      direction: 'horizontal',
      position: 0.25,
      snap: 'middle',
    },
    bottommiddle: {
      direction: 'horizontal',
      position: 0.75,
      snap: 'middle',
    },
  },

  basic: {
    centre: {
      direction: 'vertical',
      position: 0.5,
      snap: 'middle',
    },
    middle: {
      direction: 'horizontal',
      position: 0.5,
      snap: 'middle',
    },
  },

  box: {
    left: {
      direction: 'vertical',
      position: 0,
      snap: 'edge',
    },
    right: {
      direction: 'vertical',
      position: 1,
      snap: 'edge',
    },
    top: {
      direction: 'horizontal',
      position: 0,
      snap: 'edge',
    },
    bottom: {
      direction: 'horizontal',
      position: 1,
      snap: 'edge',
    },
  },

  margin: {
    marginLeft: {
      direction: 'vertical',
      position: 0.05,
      snap: 'edge',
    },
    marginRight: {
      direction: 'vertical',
      position: 0.95,
      snap: 'edge',
    },
    marginTop: {
      direction: 'horizontal',
      position: 0.05,
      snap: 'edge',
    },
    marginBottom: {
      direction: 'horizontal',
      position: 0.95,
      snap: 'edge',
    },
  },

  ruleOfThirds: {
    x0: {
      direction: 'vertical',
      position: 0,
      snap: 'edge',
      clipping: 'bounds',
    },
    x1: {
      direction: 'vertical',
      position: 0.33,
      snap: 'edge',
      clipping: 'bounds',
    },
    x2: {
      direction: 'vertical',
      position: 0.66,
      snap: 'edge',
      clipping: 'bounds',
    },
    x3: {
      direction: 'vertical',
      position: 1,
      snap: 'edge',
      clipping: 'bounds',
    },
    y0: {
      direction: 'horizontal',
      position: 0,
      snap: 'edge',
      clipping: 'bounds',
    },
    y1: {
      direction: 'horizontal',
      position: 0.33,
      snap: 'edge',
      clipping: 'bounds',
    },
    y2: {
      direction: 'horizontal',
      position: 0.66,
      snap: 'edge',
      clipping: 'bounds',
    },
    y3: {
      direction: 'horizontal',
      position: 1,
      snap: 'edge',
      clipping: 'bounds',
    },
  },

  instaStory: {
    x0: {
      direction: 'vertical',
      position: 0,
      snap: 'edge',
      clipping: 'bounds',
    },
    x1: {
      direction: 'vertical',
      position: 0.1,
      snap: 'edge',
      clipping: 'bounds',
    },
    x2: {
      direction: 'vertical',
      position: 0.9,
      snap: 'edge',
      clipping: 'bounds',
    },
    x3: {
      direction: 'vertical',
      position: 1,
      snap: 'edge',
      clipping: 'bounds',
    },
    y0: {
      direction: 'horizontal',
      position: 0,
      snap: 'edge',
      clipping: 'bounds',
    },
    y1: {
      direction: 'horizontal',
      position: 0.13,
      snap: 'edge',
      clipping: 'bounds',
    },
    y2: {
      direction: 'horizontal',
      position: 0.87,
      snap: 'edge',
      clipping: 'bounds',
    },
    y3: {
      direction: 'horizontal',
      position: 1,
      snap: 'edge',
      clipping: 'bounds',
    },
  },

  instaCarousel: {
    x0: {
      direction: 'vertical',
      position: 0,
      snap: 'edge',
      clipping: 'bounds',
    },
    x1: {
      direction: 'vertical',
      position: 0.1,
      snap: 'edge',
      clipping: 'bounds',
    },
    x2: {
      direction: 'vertical',
      position: 0.2,
      snap: 'edge',
      clipping: 'bounds',
    },
    x3: {
      direction: 'vertical',
      position: 0.3,
      snap: 'edge',
      clipping: 'bounds',
    },
    x4: {
      direction: 'vertical',
      position: 0.4,
      snap: 'edge',
      clipping: 'bounds',
    },
    x5: {
      direction: 'vertical',
      position: 0.5,
      snap: 'edge',
      clipping: 'bounds',
    },
    x6: {
      direction: 'vertical',
      position: 0.6,
      snap: 'edge',
      clipping: 'bounds',
    },
    x7: {
      direction: 'vertical',
      position: 0.7,
      snap: 'edge',
      clipping: 'bounds',
    },
    x8: {
      direction: 'vertical',
      position: 0.8,
      snap: 'edge',
      clipping: 'bounds',
    },
    x9: {
      direction: 'vertical',
      position: 0.9,
      snap: 'edge',
      clipping: 'bounds',
    },
    x10: {
      direction: 'vertical',
      position: 1,
      snap: 'edge',
      clipping: 'bounds',
    },
    y0: {
      direction: 'horizontal',
      position: 0,
      snap: 'edge',
      clipping: 'bounds',
    },
    y1: {
      direction: 'horizontal',
      position: 1,
      snap: 'edge',
      clipping: 'bounds',
    },
  },

  whiteSpaceEdges: {
    x0: {
      direction: 'vertical',
      position: 0.1,
      snap: 'edge',
      clipping: 'bounds',
    },
    x1: {
      direction: 'vertical',
      position: 0.9,
      snap: 'edge',
      clipping: 'bounds',
    },
    y0: {
      direction: 'horizontal',
      position: 0.1,
      snap: 'edge',
      clipping: 'bounds',
    },
    y1: {
      direction: 'horizontal',
      position: 0.9,
      snap: 'edge',
      clipping: 'bounds',
    },
  },
};

export class OmniCanvasGuideline {
  visible = false;
  enabled = true;

  constructor(controller, direction, position, options = {}) {
    this.controller = controller;
    this.direction = direction;
    this.position = position;
    this.snap = options.snap || 'middle';
    this.clipping = options.clipping || 'none';
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  get guidelinePoint() {
    const bounds = this.controller?.boundingBox;

    if (this.direction === 'horizontal') {
      return bounds.height * this.position;
    }

    return bounds.width * this.position;
  }

  getElementPoint(element) {
    if (!element.outerBounds) {
      element.outerBounds = element.calculateOuterBounds();
    }
    const elementBounds = element.outerBounds;
    const bounds = this.controller?.boundingBox;
    const centerPoint = element.centerPoint();

    let elementPoint;

    if (this.snap === 'edge') {
      if (this.direction === 'vertical') {
        if (centerPoint.x > bounds.width * this.position) {
          elementPoint = element.position.translate(
            elementBounds.tl.x / this.controller?.params?.scale ?? 1,
            elementBounds.tl.y / this.controller?.params?.scale ?? 1
          );
        } else {
          elementPoint = element.position.translate(
            elementBounds.br.x / this.controller?.params?.scale ?? 1,
            elementBounds.br.y / this.controller?.params?.scale ?? 1
          );
        }
      }

      if (this.direction === 'horizontal') {
        if (centerPoint.y > bounds.height * this.position) {
          elementPoint = element.position.translate(
            elementBounds.tl.x / this.controller?.params?.scale ?? 1,
            elementBounds.tl.y / this.controller?.params?.scale ?? 1
          );
        } else {
          elementPoint = element.position.translate(
            elementBounds.br.x / this.controller?.params?.scale ?? 1,
            elementBounds.br.y / this.controller?.params?.scale ?? 1
          );
        }
      }
    } else {
      elementPoint = element.centerPoint();
    }

    if (this.direction === 'horizontal') {
      elementPoint = elementPoint.y;
    } else if (this.direction === 'vertical') {
      elementPoint = elementPoint.x;
    }

    return elementPoint;
  }

  distanceToElement(element) {
    const guidelinePoint = this.guidelinePoint;
    const elementPoint = this.getElementPoint(element);

    return guidelinePoint - elementPoint;
  }

  intersectsWith(element) {
    const canvasScale = this.controller?.getPixelScale?.() ?? 1;
    const snapTo = Math.floor(
      this.controller?.params?.snapping.position * canvasScale
    );

    return Math.abs(this.distanceToElement(element)) < snapTo;
  }

  snapElement(element) {
    const distance = this.distanceToElement(element);
    const direction = this.direction;
    element.translate(
      direction === 'vertical' ? distance : 0,
      direction === 'horizontal' ? distance : 0
    );
  }

  render() {
    const virtualCanvas = this.controller?.renderer?.virtualCanvas;
    const bounds = this.controller?.boundingBox;

    const xCenter = bounds.position.x + bounds.width / 2;
    const yCenter = bounds.position.y + bounds.height / 2;

    let x1 = 0;
    let y1 = 0;
    let x2 = 0;
    let y2 = 0;

    if (this.direction === 'horizontal') {
      if (this.clipping === 'bounds') {
        x1 = bounds.position.x;
        x2 = bounds.position.x + bounds.width;
      } else {
        x2 = virtualCanvas.width;
      }
      y1 = bounds.position.y + bounds.height * this.position;
      y2 = y1;
    } else if (this.direction === 'vertical') {
      if (this.clipping === 'bounds') {
        y1 = bounds.position.y;
        y2 = bounds.position.y + bounds.height;
      } else {
        y2 = virtualCanvas.height;
      }
      x1 = bounds.position.x + bounds.width * this.position;
      x2 = x1;
    }

    virtualCanvas.strokeLine(
      this.applyScaleToPoint(x1, xCenter),
      this.applyScaleToPoint(y1, yCenter),
      this.applyScaleToPoint(x2, xCenter),
      this.applyScaleToPoint(y2, yCenter)
    );
  }

  applyScaleToPoint(value, center) {
    const scale = this.controller?.params?.scale ?? 1;
    return value - (center - value) * (scale - 1);
  }
}
